import { render, staticRenderFns } from "./TicketTab.vue?vue&type=template&id=422c58c6&"
import script from "./TicketTab.vue?vue&type=script&lang=js&"
export * from "./TicketTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VExpansionPanels,VForm})
